<template>
	<v-app>
		<core-view />
	</v-app>
</template>

<script>
export default {
	props: {
		source: String,
	},
	data: () => ({
		drawer: null,
	}),
	components: {
		CoreView: () => import('@/components/core/default/View'),
	},
};
</script>
